module.exports = __webpack_public_path__ + "img/767.2431bf97.png";